import { createContext, useContext } from 'react';

import type { VoiceError, VoiceStatus } from '../voiceTypes.js';

export type VoiceContextType = {
  connect: () => Promise<void>;
  disconnect: () => void;
  isMuted: boolean;
  isAudioMuted: boolean;
  isPlaying: boolean;
  mute: () => void;
  unmute: () => void;
  muteAudio: () => void;
  unmuteAudio: () => void;
  status: VoiceStatus;
  error: VoiceError | null;
  isError: boolean;
  isMicrophoneError: boolean;
  isSocketError: boolean;
  isAudioError: boolean;
  callDurationTimestamp: string | null;
  playerQueueLength: number;
};

export const VoiceContext = createContext<VoiceContextType | null>(null);

export const useVoice = () => {
  const ctx = useContext(VoiceContext);

  if (!ctx) {
    throw new Error('useVoice must be used within a VoiceProvider');
  }

  return ctx;
};
